<template>
	<li class="article-list-item" >
		<h4 class="title">
			<a v-bind:href="result.NodeAliasPath" v-bind:title="result.Title">{{ result.Title }}</a>
		</h4>
		<div class="meta">
			<span class="date">{{ formatDate(result.ArticleDate) }}</span>
			<!--<span class="views">{{ result.ViewCount }} views</span>-->
		</div>
	</li>

</template>


<script>
	import DateFormatService from '../../common/date-format.service';

    export default {
	props: {
			result: {
				type: Object,
				default: () => {}
			},
		},

	data: function() {
		return  {

		}
	},
	methods: {
			formatDate: function(date) {
				return DateFormatService.formatDate(date);
			}
	}
}
</script>